import React from "react";
// import Ellipsis from "react-ellipsis-pjs";
import { Tooltip, Popover } from "antd";


export function ellipsisTextWithHtml(text, html) {
    return(<Popover
        className={"ellipsishtml"}
        content={<div dangerouslySetInnerHTML={{__html: html && `<div>${html}</div>` || text}} />} 
        trigger={"hover"}
        destroyTooltipOnHide={true}
    >
        {text}
    </Popover>);
}

export function ellipsisText(text) {
    return(<Tooltip title={text}>{text}</Tooltip>);
    // return (
    //     <Ellipsis
    //         text={text}
    //         render={(ellipsisText, isEllipsis) => {
    //             if (!isEllipsis) return ellipsisText;
    //             return (
    //                 <Tooltip title={text}>{ellipsisText}</Tooltip>
    //             );
    //         }}
    //     />
    // );
}